import React from "react";
import { StatusEnum } from "../../hoc/with-status";
import { Text } from "../typography";
import { Button, ButtonSize, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { MessageBanner } from "@amzn/stencil-react-components/message-banner";
import useArb from "../../hooks/use-arb";

interface PICProps {
  status: StatusEnum;
  navigateToUrl: () => void;
  buttonRemove: boolean;
}

export const PIC = ({ status, navigateToUrl, buttonRemove }: PICProps) => {
  const bundle = useArb("HVHChecklistPantherResource");

  const text = bundle.getMessage("Checklist-PIC-Details");
  const banner = bundle.getMessage("Checklist-PIC-Message");
  const buttonText = bundle.getMessage("Checklist-PIC-ButtonText");
  return (
    <Col gridGap="1rem">
      {(!status || status === StatusEnum.API_ERROR || status === StatusEnum.INELIGIBLE) && (
        <MessageBanner>{banner}</MessageBanner>
      )}
      <Text>{text}</Text>
      {!buttonRemove && (
        <Row gridGap="1rem">
          <Button size={ButtonSize.Small} variant={ButtonVariant.Primary} onClick={navigateToUrl}>
            {buttonText}
          </Button>
        </Row>
      )}
    </Col>
  );
};
